import { extend } from 'vee-validate';
import store from '@state/store';

extend('geneCombinationExists', {
  validate: async (value) => {
    const result = await store.dispatch('createTemplate/geneCombinationExists', value);
    return !result;
  },
  message: 'Gene combination already exists!'
});

extend('geneCombinationGenesUnique', {
  validate: (value) => {
    const arr = value.split(',').map((x) => x.trim());
    return (new Set(arr)).size === arr.length;
  },
  message: 'Some of the genes have the same code'
});

export default {};
